<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 100%"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSchedule">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />Permiso
        </v-btn>
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard">
        <CardsView
          :items="paginatedItems"
          :openDialog="openDialog"
          :title="title"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-else>
        <TableWithSearch
          :items="paginatedItems"
          :headers="allHeaders"
          :title="title"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-row class="ma-0 pa-0" justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-pagination
            v-if="employees?.length > 0"
            class="paginado ma-0 pa-0"
            v-model="currentPage"
            :length="totalPages"
            prev-icon="mdi-chevron-left"
            next-icon="mdi-chevron-right"
            hide-delimiter-background
            :items-per-page="limit"
            @input="changePage"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-dialog
      v-model="openEmployee"
      max-width="600px"
      persistent
      @keydown.esc="cancel"
    >
      <v-card max-width="600px">
        <v-card-title
          style="display: flex; justify-content: center"
          class="mb-5"
        >
          {{ mode }}
        </v-card-title>
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mr-1 ml-1"
        >
          {{ alertValidate }}</v-alert
        >
        <v-form
          @submit.prevent="validation"
          class="ml-5 mr-5"
          ref="form"
          v-model="valid"
        >
          <date-with-check :showCheck="true" class="mb-4" />
          <v-select
            required
            :rules="rules"
            label="Segmento"
            dense
            outlined
            class=""
            v-model="data.segment"
            :items="segments"
            item-value="id"
            item-text="name"
            @change="changeSegment"
          />
          <v-text-field
            class=""
            :label="$tc('changeSchedule.sequenceNumber')"
            dense
            outlined
            v-model="data.sequenceNumber"
            disabled
          />

          <v-text-field
            v-model="data.initialDay"
            :label="$tc('changeSchedule.initialDay')"
            outlined
            dense
            type="number"
            :max="initialDay"
            :min="1"
            :disabled="changeSeg"
            :rules="rulesDays"
          />
          <v-alert
            v-if="showLimitAlert"
            type="warning"
            dense
            outlined
            @input="showLimitAlert = false"
          >
            {{ $tc("gestionEmpleados.OnlyUpTo300Employees") }}
          </v-alert>
          <v-autocomplete
            :rules="rules"
            :label="$tc('schedules.employees')"
            outlined
            v-model="data.employees"
            :items="employeesWithSelectAll"
            multiple
            item-value="empId"
            item-text="fullName"
            :filter="customFilter"
            :search-input.sync="searchEmployee"
            v-if="typeForm == 'add'"
          >
            <template v-slot:item="{ item }">
              <v-list-item @click.stop="toggleItem(item)">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="isSelected(item)"
                    :indeterminate="isIndeterminate(item)"
                    dense
                    hide-details
                    readonly
                  />
                </v-list-item-action>
                <v-list-item-content class="ml-n3">
                  <v-list-item-title>{{
                    item.empId === "all"
                      ? item.fullName
                      : item.fullName + " (" + item.file + ")"
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2">
                <span>{{
                  item.empId === "all"
                    ? item.fullName
                    : item.fullName + " (" + item.file + ")"
                }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text text-caption">
                (+ {{ data.employees.length - 2 }} )
              </span>
            </template>
          </v-autocomplete>
          <div class="d-flex justify-space-between pb-4">
            <v-btn class="bt-exit" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn type="submit" class="bt-acept">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-row>
</template>
<script>
import permissions from "@/store/permisosDeAcceso/accessPermissions";
import employeesPermissions from "@/store/permisosDeAcceso/employees";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import date from "@/store/common/date";
import Loader from "@/components/Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DateWithCheck,
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },

  data() {
    return {
      showCard: true,
      title: this.$tc("schedules.employees"),
      titleTable: "PermisosDeAcceso_Empleados",
      color: "",
      titleDelete: "este empleado?",
      isLoading: false,
      headers: [
        {
          text: "Empleados",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Legajo",
          value: "file",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "formattedDesde",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "formattedHasta",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Segmento",
          value: "segmentName",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      maxWidth: "600px",
      valid: true,
      typeForm: "",
      itemToDelete: null,
      itemId: null,
      alert: false,
      textAlert: "",
      data: {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        employees: [],
      },
      error: false,
      alertValidate: "",
      initialDay: null,
      changeSeg: true,
      itemEdit: null,
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      rulesDays: [
        (v) =>
          (v !== null && v !== undefined && v !== "" && this.validateDays(v)) ||
          `El número está fuera del rango. El rango válido es de 1 a ${this.initialDay}`,
      ],
      currentPage: 1,
      limit: 20,
      searchEmployee: "",
      maxEmployees: 300,
      showLimitAlert: false,
      order: "apellido",
    };
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    employees() {
      return employeesPermissions.state.employees;
    },
    employeesWithSelectAll() {
      return [
        { empId: "all", fullName: "Seleccionar todos", file: "" },
        ...this.getAllEmployees,
      ];
    },
    getAllEmployees() {
      const allEmployees = this.$store.state.employees.employees;
      const selectedEmployeIds = employeesPermissions.state.employees;
      return allEmployees?.filter(
        (employees) => !selectedEmployeIds.some((e) => e.id === employees.empId)
      );
    },
    padding() {
      return permissions.state.paddingNav;
    },
    openEmployee: {
      get() {
        return employeesPermissions.state.openEmployee;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    mode: {
      get() {
        return employeesPermissions.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openDelete: {
      get() {
        return employeesPermissions.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    segments() {
      return permissions.state.permissionSegments;
    },
    validInitialDay() {
      return this.initialDay !== null;
    },
    totalPages() {
      return Math.ceil(this.employees.length / this.limit);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.limit;
      const end = start + this.limit;
      return this.employees.slice(start, end);
    },
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },

  methods: {
    isSelected(item) {
      if (item.empId === "all") {
        return this.data.employees.length === this.getAllEmployees.length;
      }

      return this.data.employees.includes(item.empId);
    },

    isIndeterminate(item) {
      if (item.empId !== "all") return false;

      return (
        this.data.employees.length > 0 &&
        this.data.employees.length < this.getAllEmployees.length
      );
    },

    toggleItem(item) {
      if (item.empId === "all") {
        const isAllSelected = this.data.employees.length > 0;

        if (isAllSelected) {
          this.data.employees = [];
          this.showLimitAlert = false;
        } else {
          const allIds = this.getAllEmployees.map((e) => e.empId);

          if (allIds.length > this.maxEmployees) {
            this.data.employees = allIds.slice(0, this.maxEmployees);
            this.showLimitAlert = true;
          } else {
            this.data.employees = allIds;
            this.showLimitAlert = false;
          }
        }

        this.searchEmployee = "";
        return;
      }

      const exists = this.data.employees.includes(item.empId);

      if (exists) {
        this.data.employees = this.data.employees.filter(
          (id) => id !== item.empId
        );
        this.showLimitAlert = false;
      } else {
        if (this.data.employees.length >= this.maxEmployees) {
          this.showLimitAlert = true;
          return;
        }

        this.data.employees = [...this.data.employees, item.empId];

        if (this.data.employees.length === this.maxEmployees) {
          this.showLimitAlert = true;
        } else {
          this.showLimitAlert = false;
        }
      }

      this.searchEmployee = "";
    },

    customFilter(item, queryText) {
      const search = queryText.toLowerCase();

      return (
        item.fullName?.toLowerCase().includes(search) ||
        item.file?.toString().toLowerCase().includes(search)
      );
    },

    changePage(page) {
      this.currentPage = page;
    },
    async refreshItems() {
      await employeesPermissions.dispatch("getEmployees");
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveForm() {
      let payload;
      switch (this.typeForm) {
        case "add":
          this.addEmployees();
          break;
        case "edit":
          this.editEmployee(payload);
          break;
        default:
          break;
      }
    },
    validation() {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.saveForm();
      } else {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);

        this.alertValidate = this.$tc("editRegistrations.required");
      }
    },
    initialDays(selectedData) {
      let inicialDay = permissions.state.permissionSegments?.find((option) => {
        return option.id == selectedData;
      });
      return inicialDay.days;
    },
    changeSegment(item) {
      const searchNumSequense = permissions.state.permissionSegments.find(
        (item) => {
          return item.segmId == item.segmId;
        }
      );
      this.changeSeg = false;
      this.data.sequenceNumber = searchNumSequense.numberSequence;
      this.initialDay = this.initialDays(this.data.segment);
    },
    validateDays(value) {
      if (!this.validInitialDay) {
        return true;
      }
      return value >= 1 && value <= this.initialDay;
    },
    goToSchedule() {
      permissions.dispatch("handleShowWindow", "schedule");
    },
    cancel() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.showLimitAlert = false;
      this.$refs.form.resetValidation();
      (this.data = {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        employees: [],
      }),
        (this.error = false);
      employeesPermissions.commit("setOpenEmployee", false);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    async openDialog(type, item) {
      this.alert = false;
      this.typeForm = type;

      permissions.commit("setPermissionId", permissions.state.permissionId);
      employeesPermissions.commit(
        "setPermissionId",
        employeesPermissions.state.permissionId
      );
      switch (this.typeForm) {
        case "add":
          this.isLoading = true;
          permissions.dispatch("getSegmentsPermissionId").then(() => {
            if (permissions.state.permissionSegments.length == 0) {
              this.alert = true;
              this.textAlert = this.$tc("schedules.noSegmentAlert");
              this.color = "#FF8D58";
            } else {
              this.$store
                .dispatch("employees/getEmployees", {
                  photo: false,
                  order: this.order,
                  soloActivos: true,
                })
                .then(() => {
                  this.isLoading = false;
                  employeesPermissions.commit(
                    "setMode",
                    this.$tc("schedules.addEmployee")
                  );
                  employeesPermissions.commit("setOpenEmployee", true);
                });
            }
          });
          break;

        case "delete":
          employeesPermissions.commit("setOpenDelete", true);
          this.itemToDelete = {
            id: item.id,
            permissionId: permissions.state.permissionId,
            from: item.from,
          };

          break;
        case "edit":
          employeesPermissions.commit(
            "setMode",
            this.$tc("schedules.editEmployee")
          );
          this.$store.dispatch("employees/getEmployees", {
            photo: false,
            order: this.order,
            soloActivos: true,
          });
          await permissions
            .dispatch("getSegmentsPermissionId")
            .then(async () => {
              const busco = permissions.state.permissionSegments?.find(
                (segment) => {
                  return segment.id == item.segmentId;
                }
              );
              this.data = {
                segment: item.segmentId,
                initialDay: item.segementDesploy,
                sequenceNumber: busco.numberSequence,
              };
            });

          this.itemEdit = {
            id: item.id,
            name: item.name,
          };
          date.commit("setDateFrom", item.from.slice(0, 10));
          date.commit("setDateTo", !item.to ? null : item.to.slice(0, 10));
          date.commit("setCheckTo", !item.to ? true : false);
          employeesPermissions.commit("setOpenEmployee", true);
          break;
        default:
          break;
      }
    },

    cardView(value) {
      this.showCard = value;
    },
    selectedEmployeesNames() {
      const names = this.$store.state.employees.employees
        .filter((item) => this.data.employees.includes(item.empId))
        .map((item) => item.fullName);

      return names;
    },
    addEmployees() {
      this.isLoading = true;
      const payload = {
        segment: this.data.segment,
        initialDay: this.data.initialDay,
        sequenceNumber: this.data.sequenceNumber,
        employees: this.data.employees,
        from: date.state.dateFrom,
        to: date.state.dateTo,
        permissionId: permissions.state.permissionId,
        names: this.selectedEmployeesNames(),
      };

      employeesPermissions.commit("setNew", payload);
      employeesPermissions
        .dispatch("new")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.addEmployeesSuccess");
          this.color = "#82A1D0";
          this.isLoading = false;
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
          this.isLoading = false;
        });

      this.cancel();
    },
    editEmployee(items) {
      const payload = {
        segment: this.data.segment,
        initialDay: this.data.initialDay,
        sequenceNumber: this.data.sequenceNumber,
        from: date.state.dateFrom,
        to: date.state.checkTo == true ? null : date.state.dateTo,
        permissionId: permissions.state.permissionId,
        id: this.itemEdit.id,
        name: this.itemEdit.name,
      };
      employeesPermissions.commit("setEdit", payload);
      employeesPermissions
        .dispatch("edit")
        .then(() => {
          this.refreshItems();
          this.alert = true;
          this.textAlert = this.$tc("schedules.editEmployeesSuccess");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancel();
    },
    deleteItem() {
      employeesPermissions.commit("setDeleteItem", this.itemToDelete);
      employeesPermissions
        .dispatch("delete")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.deleteEmployeesSuccess");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancelDelete();
    },
    cancelDelete() {
      employeesPermissions.commit("setOpenDelete", false);
    },
  },
};
</script>
<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
